import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardContext } from '../workshop-jobcard.context';

@Component({
  selector: 'app-workshop-jobcard-booking-details-modal',
  templateUrl: './workshop-jobcard-booking-details-modal.component.html',
  styleUrls: ['./workshop-jobcard-booking-details-modal.component.scss']
})
export class WorkshopJobcardBookingDetailsModalComponent {

  @Input() jobcard: any;
  @Output() jobcardChange = new EventEmitter<any>();

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    public ctx: WorkshopJobcardContext
  ) {

  }

  updateJobcard(event){
    this.jobcardChange.emit(event);
  }

  ngOnInit() {
   
  }

  close() {
    this.activeModal.close();
  }
}
